import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { getCurrentStep } from '../store/flow/selectors';
import { devices } from '../styles/viewports.styles';
import { GreetingsPretitle } from '../views-components/GreetingsPretitle';
import { StepSubtitle } from '../views-components/StepSubtitle';
import { StepTitle } from '../views-components/StepTitle';
import { Step } from './Step';
const BaseViewHeader = styled.header.withConfig({
  displayName: "BaseView__BaseViewHeader",
  componentId: "sc-3btd5l-0"
})(["margin-bottom:1.5rem;", " @media ", "{", " ", " ", "}", ""], props => props.isFramedCentredStep && `text-align: center;`, devices.desktop, props => props.isFramedCentredStep && `text-align: center; padding-top: 30px;`, props => props.isFramedCentredStep && props.stepKey === Step.HubletSelection && `margin-bottom: 0;`, props => props.isFramedCentredStep && props.stepKey === Step.JobRole && `margin-left: 20px;`, props => props.stepKey === Step.JobRole && `
  @media ${devices.tablet}{
    width: 75%;
  }
  @media ${devices.desktop} {
    width: 90%;
  }
  `);
const BaseViewHelperText = styled.div.withConfig({
  displayName: "BaseView__BaseViewHelperText",
  componentId: "sc-3btd5l-1"
})(["", ""], props => props.isFramedCentredStep && ![Step.CrmExperienceLevel, Step.ProductExperience, Step.ProblemAwareness].includes(props.stepKey) && `text-align: left;`);
export const BaseView = ({
  title,
  helperText,
  footer,
  children,
  stepKey,
  navMarker,
  preTitleMessage = '',
  addExperimentClassName = false,
  disableAnimation = false,
  expandableSubTitleSection = null
}) => {
  const currentStep = useSelector(getCurrentStep);
  const step = stepKey || currentStep;
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();

  if (!step) {
    return null;
  }

  const stepTitle = /*#__PURE__*/_jsx(StepTitle, {
    isFramedCentredStep: isFramedCentredStep,
    stepKey: step
  });

  const navMarkerName = navMarker || `${step}_VIEW`;
  const experimentSeleniumAttribute = addExperimentClassName ? {
    'data-selenium-experiment': 'EXPERIMENT'
  } : null;
  return /*#__PURE__*/_jsxs(AnimatedStepBody, {
    dataStep: step,
    disableAnimation: disableAnimation,
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsxs("div", Object.assign({
      "data-selenium": `${step}_VIEW`
    }, experimentSeleniumAttribute, {
      children: [/*#__PURE__*/_jsxs(BaseViewHeader // @ts-expect-error Expression produces a union type that is too complex to represent.
      , {
        isFramedCentredStep: isFramedCentredStep,
        stepKey: step,
        children: [/*#__PURE__*/_jsx(GreetingsPretitle, {}), /*#__PURE__*/_jsx(StepSubtitle, {
          message: preTitleMessage
        }), title || stepTitle, expandableSubTitleSection, /*#__PURE__*/_jsx(BaseViewHelperText, {
          isFramedCentredStep: isFramedCentredStep,
          stepKey: step,
          children: helperText
        })]
      }), children, footer]
    }))]
  });
};